import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import '../common/MdPage.css';
import '../Auditoria/MDAuditoria.css';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as actasService from '../../services/actas/actasService';
import {
  buildConsultarActasParams,
  classifyActasError,
  formatActaExamenTipo,
} from '../../services/actas/actasDto';
import { displayDate } from '../../services/dates/dateService';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import {
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
} from '../common/MdRowActions';

export class ConsultarActas extends Component {
  static displayName = ConsultarActas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      paginationData: [],
      perPage: 10,
      pageCount: 1,
      forcePage: 0,
      searched: false,
      filters: {
        fechaDesde: '',
        fechaHasta: '',
        folio: '',
        libro: '',
        tipoActa: '',
      },
      materia: {
        materiaCarreraCodigo: '',
        descripcion: '',
      },
      showLookupMaterias: false,
      showErrorMessage: false,
      errorMessage: '',
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => actasService.consultarActasExamen(query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState),
    });
  }

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [name]: value,
      },
      showErrorMessage: false,
      errorMessage: '',
    }));
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupMaterias: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupMaterias: false,
      showErrorMessage: false,
      errorMessage: '',
      materia: {
        materiaCarreraCodigo: carreraProperties[0],
        descripcion: `${carreraProperties[1]} - ${carreraProperties[2]} - ${carreraProperties[3]}`,
      },
    });
  };

  handleBuscar = async (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({ searched: true, showErrorMessage: false, errorMessage: '' });
    const { filters, materia } = this.state;
    try {
      await this.grid.handleFiltersChange(buildConsultarActasParams({
        fechaDesde: filters.fechaDesde,
        fechaHasta: filters.fechaHasta,
        folio: filters.folio,
        libro: filters.libro,
        tipoActa: filters.tipoActa,
        materiaCarreraCod: materia?.materiaCarreraCodigo,
      }));
    } catch (error) {
      this.handleActasError(error);
    }
  };

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleActasError(error));
  };

  buildRowActions(acta) {
    const id = acta.actaExamenCod;
    return [
      {
        key: 'watch',
        label: 'Ver Acta',
        variant: 'outline',
        icon: 'eye',
        to: `/aex/watch/${id}`,
      },
      {
        key: 'header',
        label: 'Modificar Encabezado',
        variant: 'outline',
        icon: 'pencil',
        to: `/update-eae/${id}`,
      },
    ];
  }

  renderResultsTable(actas) {
    return (
      <div className="md-page__table-card md-consultar-actas__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="consultar-actas-title">
          <thead>
            <tr>
              <th scope="col">Folio</th>
              <th scope="col">Libro</th>
              <th scope="col">Fecha examen</th>
              <th scope="col">Materia</th>
              <th scope="col">Carrera</th>
              <th scope="col">Tipo acta</th>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acciones" />
            </tr>
          </thead>
          <tbody>
            {actas.map((acta) => (
              <tr key={acta.actaExamenCod}>
                <MdTableCell>{acta.actaExamenFolio}</MdTableCell>
                <MdTableCell>{acta.actaExamenLibro}</MdTableCell>
                <MdTableCell>{displayDate(acta.mesaExamenFechaExamen)}</MdTableCell>
                <MdTableCell>{acta.materiaNombre}</MdTableCell>
                <MdTableCell>{acta.carreraNombre}</MdTableCell>
                <MdTableCell>{formatActaExamenTipo(acta.actaExamenTipo)}</MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(acta)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const controlsDisabled = this.state.loading || this.state.showErrorMessage;
    const listLoading = this.state.loading && this.state.paginationData.length === 0;
    const materiaDisplay = this.state.materia.descripcion.trim();

    let resultsContent = null;
    if (this.state.searched && !this.state.loading) {
      resultsContent = this.state.paginationData.length > 0
        ? this.renderResultsTable(this.state.paginationData)
        : <p className="md-page__empty-state">No hay resultados</p>;
    } else if (listLoading) {
      resultsContent = <p className="md-page__loading"><em>Cargando resultados...</em></p>;
    }

    return (
      <div className="md-page md-form-page md-consultar-actas">
        <div className="md-page__header">
          <h1 id="consultar-actas-title" className="md-page__title">Consulta de Actas de Exámenes</h1>
        </div>

        <p className="md-form-page__subtitle">
          Filtre por fechas, libro, folio, tipo de acta o materia y busque actas de examen.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <div className="md-form-page__card md-auditoria__filters-card">
          <form className="md-form-page__form md-auditoria__filters-form" onSubmit={this.handleBuscar} noValidate>
            <div className="md-auditoria__filters-bar">
              <div className="md-form-page__field md-auditoria__field--date">
                <label className="md-form-page__label" htmlFor="consultar-actas-fecha-desde">
                  Desde
                </label>
                <input
                  id="consultar-actas-fecha-desde"
                  className="md-form-page__input"
                  type="date"
                  name="fechaDesde"
                  disabled={controlsDisabled}
                  value={this.state.filters.fechaDesde}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field md-auditoria__field--date">
                <label className="md-form-page__label" htmlFor="consultar-actas-fecha-hasta">
                  Hasta
                </label>
                <input
                  id="consultar-actas-fecha-hasta"
                  className="md-form-page__input"
                  type="date"
                  name="fechaHasta"
                  disabled={controlsDisabled}
                  value={this.state.filters.fechaHasta}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-actas-folio">
                  Folio
                </label>
                <input
                  id="consultar-actas-folio"
                  className="md-form-page__input"
                  type="text"
                  name="folio"
                  disabled={controlsDisabled}
                  value={this.state.filters.folio}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-actas-libro">
                  Libro
                </label>
                <input
                  id="consultar-actas-libro"
                  className="md-form-page__input"
                  type="text"
                  name="libro"
                  disabled={controlsDisabled}
                  value={this.state.filters.libro}
                  onChange={this.handleFilterChange}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="consultar-actas-tipo">
                  Tipo acta
                </label>
                <select
                  id="consultar-actas-tipo"
                  className="md-form-page__input"
                  name="tipoActa"
                  disabled={this.state.loading}
                  value={this.state.filters.tipoActa}
                  onChange={this.handleFilterChange}
                >
                  <option value="">Todas</option>
                  <option value="L">Libre</option>
                  <option value="R">Regular</option>
                  <option value="E">Equivalencia</option>
                  <option value="P">Promoción</option>
                </select>
              </div>

              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary md-auditoria__search-btn"
                disabled={controlsDisabled}
              >
                Buscar
              </button>
            </div>

            <div className="md-consultar-actas__materia-row">
              <div className="md-consultar-actas__materia-label-group">
                <span className="md-form-page__label">Materia</span>
                {!this.state.loading ? (
                  <button
                    type="button"
                    className="md-page__picker-link"
                    onClick={this.handleShowCarreraLookup}
                  >
                    Seleccionar la materia
                  </button>
                ) : null}
              </div>
              <div
                className="md-page__field-readonly md-page__field-readonly--single-line"
                title={materiaDisplay}
              >
                {materiaDisplay || '\u00a0'}
              </div>
            </div>
          </form>
        </div>

        {this.state.showLookupMaterias ? (
          <LookupMaterias
            selectItem={this.handleSelectCarreraItem}
            hideLookup={this.handleHideLookup}
          />
        ) : null}

        {resultsContent}

        {!this.state.loading && this.state.paginationData.length > 0 && this.state.pageCount > 1 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              forcePage={this.state.forcePage}
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </div>
    );
  }

  handleActasError(error) {
    const outcome = classifyActasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }
}
